import { lazy } from 'react'

import { ChatChannelRBAC } from '../pages/ChatModeration/ChatChannel/rbac'
import { BannedKeywordRBAC } from '../pages/ChatModeration/BannedKeyword/rbac'

const ChatChannel = lazy(() => import('../pages/ChatModeration/ChatChannel'))
const BannedKeyword = lazy(() => import('../pages/ChatModeration/BannedKeyword'))

export const ChatChannelRouter: RouterFeatureInterface<
  'ChatChannelRouter',
  '/dashboard/chat-moderation/chat-channels'
> = {
  name: 'ChatChannelRouter',
  Component: ChatChannel,
  path: '/dashboard/chat-moderation/chat-channels',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: ChatChannelRBAC.pageID,
}

export const BannedKeywordRouter: RouterFeatureInterface<
  'BannedKeywordRouter',
  '/dashboard/chat-moderation/banned-keywords'
> = {
  name: 'BannedKeywordRouter',
  Component: BannedKeyword,
  path: '/dashboard/chat-moderation/banned-keywords',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: BannedKeywordRBAC.pageID,
}

const ChatModerationRouter = [ChatChannelRouter, BannedKeywordRouter]

export default ChatModerationRouter
